import {Auth} from "../firebase/auth";
import {IUsuario} from "services-comun-ed/modules/services/usuarios/interface";
import {RecursosWebFrontendRequest} from "services-comun-ed/modules/services/recursos/frontend-web";
import dominio from "services-comun-ed/modules/portal/ed";

export class UsuarioPerfilController {

    /* INSTANCE */
    public static instance: UsuarioPerfilController;
    private readonly name: HTMLInputElement;
    private readonly save: HTMLButtonElement;
    private readonly updatePassword: HTMLButtonElement;
    private readonly uploadImage: HTMLButtonElement;
    private readonly fileInput: HTMLInputElement;
    private readonly photo: HTMLImageElement;
    private password: HTMLInputElement;
    private readonly baja: HTMLElement;

    /* STATIC */
    public static async build(): Promise<void> {
        UsuarioPerfilController.instance = new this();
    }

    private constructor() {
        this.name = document.querySelector("#nombre") as HTMLInputElement;
        this.save = document.querySelector("#save-user") as HTMLButtonElement;
        this.updatePassword = document.querySelector("#save-pass") as HTMLButtonElement;
        this.password = document.querySelector("#newpassword") as HTMLInputElement;
        this.uploadImage = document.querySelector(".upload-image") as HTMLButtonElement;
        this.fileInput = document.querySelector("#fileInput") as HTMLInputElement;
        this.photo = document.querySelector(".foto") as HTMLImageElement;
        this.baja = document.querySelector("#baja-user") as HTMLElement;
        if (this.name && this.save && this.baja && this.updatePassword && this.uploadImage) this.initForm();
    }

    private initForm(): void {
        this.save.addEventListener("click", this.saveUser.bind(this));
        this.baja.addEventListener("click", this.deleteUser.bind(this));
        this.updatePassword.addEventListener("click", this.updatePass.bind(this));
        this.uploadImage.addEventListener("click", this.openWindow.bind(this));
        this.fileInput.addEventListener("change", this.uploadUserImage.bind(this));
    }

    private async openWindow(): Promise<void> {
        this.fileInput.click();
    }

    private async uploadUserImage(): Promise<void> {
        const file = this.fileInput.files?.[0];
        if (file) {
            const maxSize = 1024 * 1024;
            const form = new FormData();
            form.append('imagen', file);
            if (file.size > maxSize) return;
            const resp = await RecursosWebFrontendRequest.uploadImage(form);
            const instance = Auth.get();
            if (instance) {
                instance.userEd!.avatar = dominio.get(dominio.WWW) + "/" + resp.pathStorage;
                await instance.update(instance.userEd);
                this.photo.src = instance.userEd!.avatar;
            }
        }
    }

    private async updatePass(): Promise<void> {
        const instance = Auth.get();
        if (instance) {
            await instance.changePassword(instance.userFb!, this.password.value);
        }
    }

    private async saveUser(): Promise<void> {
        const user = Auth.get()?.userEd as IUsuario;
        if (this.name.textContent != null && this.name.value.length > 0) {
            user.nombre = this.name.value;
            await Auth.get()?.update(user);
        }
    }

    private deleteUser(): void {
        if (document.querySelector(".pregunta-baja-usuario")) return;
        const button_si = document.createElement("button");
        button_si.classList.add("opcion");
        button_si.classList.add("si");
        button_si.textContent = "Si, estoy segur@";
        button_si.addEventListener('click', async ()=> {
            await Auth.get()?.delete();
        });
        const button_no = document.createElement("button");
        button_no.classList.add("opcion");
        button_no.classList.add("no");
        button_no.textContent = "No, deseo conservar mi cuenta";
        button_no.addEventListener('click', ()=> {
            document.querySelector(".pregunta-baja-usuario")?.remove();
        });
        const span_info = document.createElement("span");
        span_info.textContent = "¿Estás segur@ de que quieres dar de baja tu cuenta?";
        const span_main = document.createElement("span");
        span_main.classList.add("pregunta-baja-usuario");
        span_main.appendChild(span_info);
        span_main.appendChild(button_no);
        span_main.appendChild(button_si);
        this.baja.parentElement?.insertAdjacentElement("afterend", span_main);
    }

}
